// src/utils/auth.js

export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const expiry = localStorage.getItem("expiry");

  // Basic check
  if (!token || !user || isLoggedIn !== "true") {
    return false;
  }

  // Expiry check
  if (expiry && Date.now() > Number(expiry)) {
    localStorage.clear(); // Clear everything if expired
    return false;
  }

  return true;
};

// Optional: Helper to clear all auth data
export const clearAuthData = () => {
  localStorage.clear();
};
